import { FC, useContext, useState, createContext, useMemo, useCallback } from 'react';
import { SideMenuOpenContextValue } from './SideMenu.types';

export const SideMenuOpenContext = createContext<SideMenuOpenContextValue | undefined>(undefined);

export const SideMenuProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSideMenuMobileOpen, setIsSideMenuMobileOpen] = useState(false);
  const [isSideMenuOpen, setSideMenuOpen] = useState(false);
  const toggleOpenState = useCallback(() => setIsSideMenuMobileOpen((isOpen) => !isOpen), []);

  const memoizedContextValue = useMemo(
    () => ({
      isSideMenuMobileOpen,
      toggleOpenState,
      isSideMenuOpen,
      setSideMenuOpen,
    }),
    [isSideMenuMobileOpen, toggleOpenState, isSideMenuOpen, setSideMenuOpen]
  );

  return <SideMenuOpenContext.Provider value={memoizedContextValue} children={children} />;
};

export const useSideMenu = () => {
  const value = useContext(SideMenuOpenContext);

  if (!value) {
    throw new Error('You need to wrap your component with SideMenuProvider');
  }

  return value;
};
